module.exports = __webpack_public_path__ + "static/img/11.e52a8431.png";